<app-thought-form
  [thought]="thought"
  (thoughtSaved)="thoughtSaved($event)"
  (thoughtCancelled)="thoughtCancelled($event)"
  (thoughtDeleted)="thoughtDeleted($event)"
  (sharesUpdated)="isShared()"></app-thought-form>